import { createApi } from '@reduxjs/toolkit/query/react';

// Utils
import baseQuery from 'src/services/baseQuery';

export const metricsApi = createApi({
  baseQuery: baseQuery({
    baseUrl: '/platform/metrics'
  }),
  reducerPath: 'metricsapi',
  tagTypes: [],
  endpoints: builder => ({
    backfillMetrics: builder.mutation<null, { accountId: number }>({
      query: request => {
        return {
          method: 'POST',
          url: '/admin/sync-hydra',
          body: request
        };
      }
    })
  })
});

export const { useBackfillMetricsMutation } = metricsApi;

export default metricsApi;
